import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Tutor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99 5.065a.89.89 0 0 0-.894.894v26.51c0 .492.392.894.908.894h3.493a1.048 1.048 0 1 1 0 2.096H3.004A2.989 2.989 0 0 1 0 32.469V5.96a2.985 2.985 0 0 1 2.99-2.99h38.02A2.985 2.985 0 0 1 44 5.96v26.51a2.985 2.985 0 0 1-2.99 2.99h-3.913a1.048 1.048 0 1 1 0-2.096h3.913a.89.89 0 0 0 .894-.894V5.96a.89.89 0 0 0-.894-.894H2.99Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.007 11.867a5.253 5.253 0 1 0 5.254 5.252c0-2.9-2.352-5.252-5.254-5.252Zm-7.35 5.252a7.348 7.348 0 0 1 7.35-7.347c4.06 0 7.35 3.29 7.35 7.347a7.348 7.348 0 0 1-7.35 7.347c-4.06 0-7.35-3.29-7.35-7.347ZM22.007 28.53a7.848 7.848 0 0 0-7.853 7.85v2.878c0 .275.232.517.531.517h14.658c.287 0 .517-.23.517-.517V36.38a7.848 7.848 0 0 0-7.853-7.85Zm-9.949 7.85c0-5.495 4.452-9.945 9.949-9.945s9.948 4.45 9.948 9.945v2.878a2.61 2.61 0 0 1-2.612 2.612H14.685c-1.433 0-2.627-1.156-2.627-2.612V36.38Z"
  }));
});
Tutor.displayName = 'Tutor';
Tutor.defaultProps = {
  'aria-label': 'Tutor'
};
export default Tutor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Tutor.js
// module id = 3939
// module chunks = 11